/** Words that appear on every screen — buttons, states, table chrome. */
export const COMMON_STRINGS = {
    'common.save': { en: 'Save', ru: 'Сохранить' },
    'common.saved': { en: 'Saved', ru: 'Сохранено' },
    'common.saving': { en: 'Saving…', ru: 'Сохранение…' },
    'common.cancel': { en: 'Cancel', ru: 'Отмена' },
    'common.close': { en: 'Close', ru: 'Закрыть' },
    'common.delete': { en: 'Delete', ru: 'Удалить' },
    'common.remove': { en: 'Remove', ru: 'Убрать' },
    'common.edit': { en: 'Edit', ru: 'Изменить' },
    'common.add': { en: 'Add', ru: 'Добавить' },
    'common.create': { en: 'Create', ru: 'Создать' },
    'common.rename': { en: 'Rename', ru: 'Переименовать' },
    'common.confirm': { en: 'Confirm', ru: 'Подтвердить' },
    'common.apply': { en: 'Apply', ru: 'Применить' },
    'common.refresh': { en: 'Refresh', ru: 'Обновить' },
    'common.search': { en: 'Search', ru: 'Поиск' },
    'common.filter': { en: 'Filter', ru: 'Фильтр' },
    'common.loading': { en: 'Loading…', ru: 'Загрузка…' },
    'common.none': { en: '— None —', ru: '— Нет —' },
    'common.yes': { en: 'Yes', ru: 'Да' },
    'common.no': { en: 'No', ru: 'Нет' },
    'common.on': { en: 'On', ru: 'Вкл' },
    'common.off': { en: 'Off', ru: 'Выкл' },
    'common.online': { en: 'Online', ru: 'В сети' },
    'common.offline': { en: 'Offline', ru: 'Не в сети' },
    'common.enabled': { en: 'Enabled', ru: 'Включено' },
    'common.disabled': { en: 'Disabled', ru: 'Отключено' },
    'common.start': { en: 'Start', ru: 'Запустить' },
    'common.stop': { en: 'Stop', ru: 'Остановить' },
    'common.restart': { en: 'Restart', ru: 'Перезапустить' },
    'common.copy': { en: 'Copy', ru: 'Копировать' },
    'common.copied': { en: 'Copied', ru: 'Скопировано' },
    'common.back': { en: 'Back', ru: 'Назад' },
    'common.never': { en: 'Never', ru: 'Никогда' },
    'common.unknown': { en: 'Unknown', ru: 'Неизвестно' },
    'common.error': { en: 'Error', ru: 'Ошибка' },
    'common.forbidden': { en: 'Forbidden', ru: 'Нет доступа' },
    'common.failed_to_load': { en: 'Failed to load', ru: 'Не удалось загрузить' },
    'common.failed_to_save': { en: 'Failed to save', ru: 'Не удалось сохранить' },
    'common.failed_to_delete': { en: 'Failed to delete', ru: 'Не удалось удалить' },
    'common.name': { en: 'Name', ru: 'Название' },
    'common.status': { en: 'Status', ru: 'Статус' },
    'common.actions': { en: 'Actions', ru: 'Действия' },
    'common.team': { en: 'Team', ru: 'Команда' },
    'common.device': { en: 'Device', ru: 'Устройство' },
    'common.devices': { en: 'Devices', ru: 'Устройства' },
    'common.farm': { en: 'Farm', ru: 'Ферма' },
    'common.settings': { en: 'Settings', ru: 'Настройки' },
    'common.all': { en: 'All', ru: 'Все' },
    'common.n_selected': { en: '{n} selected', ru: 'Выбрано: {n}' },
};
